// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contas_AtualizaContaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for PUT /contas/atualiza_conta/{id}
 *
 * Echoes the updated conta_id. Wire shape preserves the legacy
 * `{ conta_id: int }` object emit.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Contas_AtualizaContaResponseDados {
conta_id: number
}

export type Contas_AtualizaContaResponse = ApiResponse<Contas_AtualizaContaResponseDados>;

registerResponseContract('Contas_AtualizaContaResponse', {
  conta_id: { type: 'number',  required: true },
})
